/*
 * Sticky ATC Bar - mobile only.
 * Deferred so it doesn't block. Uses requestIdleCallback so init never competes
 * with critical above-the-fold work.
 */
(function () {
  'use strict';

  // Mobile-only - bail on desktop
  if (window.matchMedia && !window.matchMedia('(max-width: 768px)').matches) {
    return;
  }

  function init() {
    var stickyBar = document.getElementById('sticky-atc-bar');
    if (!stickyBar) return;
    stickyBar.removeAttribute('hidden');

    var triggerBtn = document.getElementById('sticky-trigger-btn');
    var closeBtn = document.getElementById('sticky-close-btn');
    var isClosed = false;

    var mainAtcBtn =
      document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
      document.querySelector('.product-form__submit');

    var productFormArea =
      document.querySelector('.product-form') ||
      document.querySelector('form[action*="/cart/add"]');

    if (mainAtcBtn) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (isClosed) return;
          var entry = entries[0];
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            stickyBar.classList.add('sticky-atc-visible');
          } else {
            stickyBar.classList.remove('sticky-atc-visible');
          }
        },
        { threshold: 0 }
      );
      observer.observe(mainAtcBtn);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        stickyBar.classList.remove('sticky-atc-visible');
        isClosed = true;
      });
    }

    if (triggerBtn && mainAtcBtn) {
      triggerBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (triggerBtn.textContent.trim() === 'SELECT OPTION') {
          if (productFormArea) {
            productFormArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          setTimeout(function () {
            mainAtcBtn.style.opacity = '0.5';
            setTimeout(function () {
              mainAtcBtn.style.opacity = '1';
            }, 300);
          }, 800);
        } else {
          mainAtcBtn.click();
          triggerBtn.textContent = 'ADDING...';
          setTimeout(function () {
            triggerBtn.textContent = 'ADD TO CART';
          }, 2000);
        }
      });
    }
  }

  function schedule(fn) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: 2000 });
    } else {
      setTimeout(fn, 1);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(init); });
  } else {
    schedule(init);
  }
})();